import { createContext, useContext } from 'react';

import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';

const AnalyticsContext = createContext<Analytics | undefined>(undefined);

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return context;
};

export const AnalyticsProvider = ({
  value,
  children,
}: {
  value: Analytics;
  children: React.ReactNode;
}) => (
  <AnalyticsContext.Provider value={value}>
    {children}
  </AnalyticsContext.Provider>
);

export const MockAnalyticsProvider = ({
  value,
  children,
}: {
  value: Partial<Analytics>;
  children: React.ReactNode;
}) => (
  <AnalyticsContext.Provider value={value as Analytics}>
    {children}
  </AnalyticsContext.Provider>
);
